import CrossSell from './CrossSell';
import formatPrismicData from '../../hocs/formatPrismicData';
import withFilteredProductItems from '../../hocs/withFilteredProductItems';
import compose from 'recompose/compose';
import withMedia from 'src/client/js/view/hocs/withMediaQueries';

const enhance = compose(
  withFilteredProductItems,
  formatPrismicData,
  withMedia,
);

export default enhance(CrossSell);



// WEBPACK FOOTER //
// ./src/client/js/view/components/CrossSell/index.js